/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2019, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define([
	'react',
	'../../../../../lib/@waca/dashboard-common/dist/core/APIFactory',
	'../ToolbarSectionDOMAPI',
	'../ToolbarSectionComponent',
	'../../ToolbarDockAPI'
], function(React, APIFactory, ToolbarSectionDOMAPI, ToolbarSectionComponent, ToolbarDockAPI){
	class CanvasToolbarSectionDOM{
		static PROVIDER_ID = 'CanvasToolbarSection';
		static PROVIDER_INDEX = 1;
		constructor({ features }){
			this._toolbarDockDOM = features['ToolbarPanelDockDOM'];
			this._toolbarDock = features['ToolbarDock'];
		}

		initialize(){
			this._api = APIFactory.createAPI(this, [ToolbarSectionDOMAPI]);
			this._toolbarDockDOM.addProvider(CanvasToolbarSectionDOM.PROVIDER_ID, this);
		}

		getAPI(){
			return this._api;
		}

		destroy(){
			delete this._api;
			delete this._node;
		}

		/** API implementations */

		setNode(node){
			this._node = node;
		}

		getNode(){
			return this._node;
		}

		getReactElement(){
			return <ToolbarSectionComponent
				className={CanvasToolbarSectionDOM.PROVIDER_ID}
				stateProvider={this._toolbarDock}
				stateEvent={ToolbarDockAPI.UPDATE_CANVAS_TOOLBAR_STATE}
				toolbarSectionDOM={this}
			/>;
		}

		getIndex(){
			return CanvasToolbarSectionDOM.PROVIDER_INDEX;
		}
	}
	return CanvasToolbarSectionDOM;
});
